/**
 * AIS vessel-type categories — single source of truth for filter chips, marker colors,
 * and popup color dots. `code` matches the backend `shipTypeCategory()` output in
 * eetaskapi/utils/aisstream.js. Keep the two in sync.
 */
export interface AisVesselCategory {
  code: string;
  label: string;
  color: string;
}

export const AIS_VESSEL_CATEGORIES: AisVesselCategory[] = [
  { code: 'NOT_AVAILABLE',    label: 'Not Available',           color: '#9aa0a6' },
  { code: 'WING_IN_GROUND',   label: 'Wing in Ground',          color: '#25aae0' },
  { code: 'FISHING',          label: 'Fishing Vessels',         color: '#3cba54' },
  { code: 'TOWING',           label: 'Towing Vessels',          color: '#e69138' },
  { code: 'DREDGING',         label: 'Dredging',                color: '#3d85c6' },
  { code: 'MILITARY',         label: 'Military Operations',     color: '#4169e1' },
  { code: 'SAILING',          label: 'Sailing',                 color: '#e91e63' },
  { code: 'HIGH_SPEED_CRAFT', label: 'High Speed Craft',        color: '#00bcd4' },
  { code: 'SPECIAL_PURPOSE',  label: 'Special Purpose Vessels', color: '#8bc34a' },
  { code: 'PASSENGER',        label: 'Passenger Vessels',       color: '#2196f3' },
  { code: 'CARGO',            label: 'Cargo Vessels',           color: '#ff9800' },
  { code: 'TANKER',           label: 'Tankers',                 color: '#f44336' },
  { code: 'OTHER',            label: 'Other Types',             color: '#9c27b0' },
  { code: 'OFFSHORE',         label: 'Offshore',                color: '#4caf50' },
  { code: 'NON_VESSEL',       label: 'Non-Vessel',              color: '#78909c' },
];

const CATEGORY_BY_CODE = new Map(AIS_VESSEL_CATEGORIES.map((c) => [c.code, c]));

export function categoryColor(code: string | undefined | null): string {
  return CATEGORY_BY_CODE.get(String(code ?? 'OTHER'))?.color ?? '#9c27b0';
}

export function categoryLabel(code: string | undefined | null): string {
  return CATEGORY_BY_CODE.get(String(code ?? 'OTHER'))?.label ?? 'Other Types';
}
